export type LegalBlock =
  | { type: 'paragraph'; text: string }
  | { type: 'section'; number: string; title: string; bullets: string[]; tail: string }

/** Split legal plain-text into readable blocks (intro, numbered sections, bullets). */
export function parseLegalBody(body: string): LegalBlock[] {
  const blocks: LegalBlock[] = []
  const parts = body
    .split(/\n{2,}/)
    .map((p) => p.trim())
    .filter(Boolean)

  for (const part of parts) {
    const sectionMatch = part.match(/^(\d+)\.\s+([^\n]+)(?:\n([\s\S]*))?$/)
    if (sectionMatch) {
      const rest = (sectionMatch[3] ?? '').trim()
      const bullets: string[] = []
      const tailLines: string[] = []
      for (const line of rest.split('\n')) {
        const trimmed = line.trim()
        if (trimmed.startsWith('•')) {
          bullets.push(trimmed.replace(/^•\s*/, ''))
        } else if (trimmed) {
          tailLines.push(trimmed)
        }
      }
      blocks.push({
        type: 'section',
        number: sectionMatch[1],
        title: sectionMatch[2].trim(),
        bullets,
        tail: tailLines.join(' '),
      })
    } else {
      blocks.push({ type: 'paragraph', text: part })
    }
  }

  return blocks
}
